import { InputTypes } from './typings/InputProps';

export default function FormInput(props: any) {
	const { inputType = InputTypes.input, pointer, label, componentId, ...rest } = props;

	if (inputType !== 'hidden')
		return (
			<label className="vtex-input w-100" data-selection={componentId}>
				<span className="vtex-input__label db mb3 w-100 c-on-base t-small ">{label || 'Label'}</span>
				<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
					<input
						type="text"
						placeholder={`${rest.placeholder}`}
						className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
					/>
				</div>
			</label>
		);

	if (inputType == 'hidden') return null;

	return null;
}
